import Login from '../views/Login.vue'
import Agenda from '../views/Agenda.vue'
import Faturamento from '../views/Faturamento.vue'
import SebratecAgrupar from '../views/Sebraetec/agrupar/agrupar.vue'
import SebratecBaixar from '../views/Sebraetec/registrar_baixa/registrar_baixa.vue'
import Faturar from '../views/Faturar.vue'
import RetornoBanco from '../views/RetornoBanco.vue'
import Veiculos from '../views/Veiculos.vue'
import PreAgendamento from '../views/PreAgendamento.vue'
import Certificacao from '../views/Certificacao.vue'
import Nucleo from '../views/Nucleo.vue'
import Dashboard from '../views/Dashboard.vue'
import TermosAcatamento from '../views/TermosAcatamento.vue'
import FormaTrabalho from '../views/FormaTrabalho.vue'
import Tutoriais from '../views/Tutoriais.vue'
import Faturas from "../views/Faturas";
import ContratosAbertos from "../views/ContratosAbertos";
import Limite from "../views/Limite";
import Paineis from "../views/Paineis";
import Adiantamento from "../views/Adiantamento/Adiantamento.vue";
import AtendimentoPainel from '../views/AtendimentoPainel.vue'
import AtendimentoUnidades from '../views/AtendimentoUnidades.vue'
import SatisfacaoUnidades from '../views/SatisfacaoUnidades.vue'
import SatisfacaoForm from '../views/SatisfacaoForm.vue'
// import Etiquetas from '../views/Etiquetas.vue'

function isAuthenticated(to, from, next) {
  JSON.parse(localStorage.getItem('access_token'))
  ? next()
  : next('/')
}

function isAdmin(to, from, next) {
  !JSON.parse(sessionStorage.getItem('IdProfissional'))
  ? next()
  : next(from.path)
}

function validarAcessoAtendimentoPainel(to, from, next) {
  const unidade = to.query.Unidade;
  const idUnidade = to.query.IdUnidade;

  (unidade && idUnidade)
  ? next()
  : next('/atendimento')
}

function validarAcessoSatisfacaoForm(to, from, next) {
  const unidade = to.query.Unidade;
  const idUnidade = to.query.IdUnidade;

  (unidade && idUnidade)
  ? next()
  : next('/satisfacao')
}
  
export const principal = [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEach: isAuthenticated
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/satisfacao',
      name: 'SatisfacaoUnidades',
      component: SatisfacaoUnidades,
    },
    {
      path: '/satisfacaoForm',
      name: 'SatisfacaoForm',
      component: SatisfacaoForm,
      beforeEnter: validarAcessoSatisfacaoForm,
    },
    {
      path: '/paineis',
      name: 'Paineis',
      component: Paineis,
    },
    {
      path: '/atendimento',
      name: 'AtendimentoUnidades',
      component: AtendimentoUnidades,
    },

    {
      path: '/atendimentoPainel',
      name: 'AtendimentoPainel',
      component: AtendimentoPainel,
      beforeEnter:validarAcessoAtendimentoPainel
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: Agenda,
      beforeEach: isAuthenticated
    },
    {
      path: '/faturamento',
      name: 'Faturamento',
      component: Faturamento,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/sebratec_agrupar',
      name: 'SebratecAgrupar',
      component: SebratecAgrupar,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/sebratec_baixar',
      name: 'SebratecBaixar',
      component: SebratecBaixar,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/adiantamento/:Sebraetec',
      name: 'Adiantamento',
      component: Adiantamento,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin,
      params: { Sebraetec: null },
    },
    {
      path: '/faturar/:Servico/:Sebraetec',
      name: 'Faturar',
      component: Faturar,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin,
      params: { Servico: null, Sebraetec: null }
    },
    {
      path: '/retornobanco',
      name: 'RetornoBanco',
      component: RetornoBanco,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/veiculos',
      name: 'Veiculos',
      component: Veiculos,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/preagendamento',
      name: 'PreAgendamento',
      component: PreAgendamento,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/nucleo',
      name: 'Nucleo',
      component: Nucleo,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/certificacao',
      name: 'Certificacao',
      component: Certificacao,
      beforeEach: isAuthenticated
    },
    {
      path: '/contratos',
      name: 'TermosAcatamento',
      component: TermosAcatamento,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/contratos_abertos',
      name: 'ContratosAbertos',
      component: ContratosAbertos,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/formas_de_trabalho',
      name: 'FormaTrabalho',
      component: FormaTrabalho,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/faturas',
      name: 'Faturas',
      component: Faturas,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    // {
    //   path: '/etiquetas',
    //   name: 'Etiquetas',
    //   component: Etiquetas
    // }
    {
      path: '/tutoriais',
      name: 'Tutoriais',
      component: Tutoriais,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
    {
      path: '/limite',
      name: 'Limite',
      component: Limite,
      beforeEach: isAuthenticated,
      beforeEnter: isAdmin
    },
  ]